import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Laboratory() {
  const { t } = useTranslation();
  
  const handleStakeClick = () => {
    window.open('https://noderocks.io/rock-foundation/staking.html', '_blank', 'noopener,noreferrer');
  };
  
  return (
    <div className="relative w-full min-h-[70dvh] md:min-h-[100dvh] bg-dark overflow-hidden">
      {/* Cave Entrance */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-dark via-dark-lighter to-dark">
          {/* Enhanced Cave Texture */}
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1465101162946-4377e57745c3')] 
            bg-cover bg-center mix-blend-overlay opacity-30"></div>
          
          {/* Ambient Particles - Reduced for mobile */}
          {[...Array(10)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-primary rounded-full animate-twinkle"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                transform: `scale(${Math.random() * 1.5 + 0.5})`
              }}
            ></div>
          ))}
        </div>
        
        {/* Enhanced Enter Button */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-2 sm:gap-6 w-full px-4 sm:px-6">
          {/* Heading */}
          <h2 className="text-5xl sm:text-5xl lg:text-6xl font-bold text-center">
            <span className="text-transparent bg-clip-text bg-gradient-to-r 
              from-primary via-primary-light to-primary animate-gradient-x">
              {t('laboratory.title')}
            </span>
          </h2>

          {/* Laboratory Image with Scale Effect */}
          <div className="group w-full max-w-[90vw] sm:max-w-[600px] lg:max-w-[800px] aspect-[16/9] rounded-xl overflow-hidden mt-2 sm:mt-4">
            <div className="w-full h-full">
              <img 
                src="https://i.ibb.co/HtJ2Md8/6-F28-B4-C8-D4-B5-4-CDA-9-EBA-3-B613-EA85-EA6.png"
                alt="Laboratory Entrance"
                className="w-full h-full object-cover transform transition-transform duration-500 
                  group-hover:scale-110"
              />
            </div>
          </div>

          {/* Enhanced Stake Button with Zoom Animation */}
          <button 
            onClick={handleStakeClick}
            className="group relative w-full sm:w-auto mt-2 sm:mt-6"
            data-no-float="true"
          >
            {/* Glowing border effect */}
            <div className="absolute -inset-0.5 bg-gradient-to-r from-primary to-primary-light rounded-lg 
              blur opacity-75 group-hover:opacity-100 transition duration-300"></div>
            
            {/* Button content */}
            <div className="relative px-6 sm:px-12 py-3 sm:py-4 bg-dark rounded-lg flex items-center justify-center gap-3
              border border-primary/20 group-hover:border-primary/50 transition-all duration-500
              hover:scale-110 active:scale-95 w-full sm:w-auto">
              <span className="text-2xl sm:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r 
                from-primary to-primary-light">
                {t('laboratory.stakeNow')}
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}